const style = require('./survey.styl');
const cn = require('classnames/bind').bind(style);
const {Component} = require('react');
const {dispatch} = require('store');
const usersActions = require('actions/users');
const {redirect} = require('actions/routing');
const Modal = require('components/shared/modal');
const Button = require('components/shared/button');

class Survey extends Component {

    constructor(props) {
        super(props);
        this.state = {surveyComplete: false};
        this._submitReceived = false;
        this.markSurveyComplete = this.markSurveyComplete.bind(this);
        this.navigateToHomePage = this.navigateToHomePage.bind(this);
        this.handleTypeformMessage = this.handleTypeformMessage.bind(this);
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('message', this.handleTypeformMessage);
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('message', this.handleTypeformMessage);
        }
    }

    markSurveyComplete() {
        if (this._submitReceived || this.state.surveyComplete) {
            return;
        }
        this._submitReceived = true;
        dispatch(usersActions.updateAppState({
            id: this.props.params.user_id,
            classroomId: this.props.params.classroom_id,
            appState: {[`${this.props.location.query.type}SurveyComplete`]: true}
            },
            () => this.setState({surveyComplete: true})
        ));
    }

    handleTypeformMessage(event) {
        if (!event || !event.origin || event.origin.indexOf('typeform.com') === -1) {
            return;
        }

        const message = event.data;
        if (typeof message === 'string') {
            if (
                message.indexOf('typeform-submit') !== -1 ||
                message.indexOf('"type":"form-submit"') !== -1 ||
                message.indexOf('"eventName":"submit"') !== -1
            ) {
                this.markSurveyComplete();
            }
            return;
        }

        if (!message || typeof message !== 'object') {
            return;
        }

        const type = message.type || message.eventType || message.eventName;
        if (
            type === 'typeform-submit' ||
            type === 'form-submit' ||
            type === 'submit'
        ) {
            this.markSurveyComplete();
        }
    }

    navigateToHomePage() {
        dispatch(redirect('/'));
    }

    displaySubmitConfModal() {
    return (
        <Modal onClose={this.navigateToHomePage} top={false}>
            <div className={cn('modal')}>
                <div className={cn('modal-header')}>{t('surveyPage.surveyCompleteModalTitle')}</div>
                <div className={cn('modal-text')}>{t('surveyPage.surveyCompleteModalText')}</div>
                <div className={cn('modal-buttons')}>
                    <div className={cn('button-right')}>
                        <Button onClick={this.navigateToHomePage} size='large' type='regular'>
                            {t('surveyPage.surveyCompleteModalButton')}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
    }

    render() {
        if (this.state.surveyComplete) {
            return this.displaySubmitConfModal();
        }

        const embedId = this.props.params.survey_id;
        const embedLink = `https://cricketmedia.typeform.com/to/${embedId}`;
        return (
            <iframe
                title="Typeform Survey"
                src={embedLink}
                style={{position: 'static', width: '100%', height: '500px', border: 0, borderRadius: '.625rem'}}
                allow="camera; microphone; autoplay; encrypted-media;"
                allowFullScreen
            />
        );
    }
}

module.exports = Survey;
